import type { UprdrBatch } from '@shared/types/uprdr-batch.types'

const STATUSES = ['completed', 'completed', 'completed', 'in_progress', 'failed', 'pending'] as const
const NETWORKS = ['Visa', 'Mastercard', 'Amex', 'Discover'] as const

function randomItem<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]
}

function randomNetworks(): string[] {
  const count = 1 + Math.floor(Math.random() * 3)
  const shuffled = [...NETWORKS].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, count)
}

function randomDate(daysBack: number): string {
  const date = new Date()
  date.setDate(date.getDate() - Math.floor(Math.random() * daysBack))
  return date.toISOString()
}

export const mockUprdrBatches: UprdrBatch[] = Array.from({ length: 52 }, (_, i) => {
  const completed = randomDate(90)
  const updated = new Date(completed)
  updated.setHours(updated.getHours() + Math.floor(Math.random() * 48))

  return {
    id: `uprdr_${String(i + 1).padStart(4, '0')}`,
    status: randomItem(STATUSES),
    batchSize: 50 + Math.floor(Math.random() * 9950),
    successRate: Math.round((85 + Math.random() * 15) * 10) / 10,
    networks: randomNetworks(),
    batchCompleted: completed,
    batchUpdated: updated.toISOString(),
  }
})
